import {exampleBarcodeAction} from './action';

export default exampleBarcodeAction;